// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import LoanTermInput from '../loan-term';

const LoanTermInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <LoanTermInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default LoanTermInputWithAnalytics;
